<template>
  <div class="columns">
    <div class="column is-2">
      <!-- <strong>Año</strong> -->
      <div class="field has-addons">
        <p class="control">
          <button class="button is-primary" @click="selectyear('-')">
            <span class="icon">
              <span class="material-icons">keyboard_arrow_left</span>
            </span>
          </button>
        </p>
        <p class="control">
          <button class="button">
            <span>{{ period.year }}</span>
          </button>
        </p>
        <p class="control">
          <button class="button is-primary" @click="selectyear('+')">
            <span class="icon">
              <span class="material-icons">keyboard_arrow_right</span>
            </span>
          </button>
        </p>
      </div>
    </div>
    <div class="column">
      <button class="button" @click="selectmonth(1)" :class="monthclass(1)">
        <span>Ene</span>
      </button>
      <button class="button" @click="selectmonth(2)" :class="monthclass(2)">
        <span>Feb</span>
      </button>
      <button class="button" @click="selectmonth(3)" :class="monthclass(3)">
        <span>Mzo</span>
      </button>
      <button class="button" @click="selectmonth(4)" :class="monthclass(4)">
        <span>Abr</span>
      </button>
      <button class="button" @click="selectmonth(5)" :class="monthclass(5)">
        <span>Myo</span>
      </button>
      <button class="button" @click="selectmonth(6)" :class="monthclass(6)">
        <span>Jun</span>
      </button>
      <button class="button" @click="selectmonth(7)" :class="monthclass(7)">
        <span>Jul</span>
      </button>
      <button class="button" @click="selectmonth(8)" :class="monthclass(8)">
        <span>Ago</span>
      </button>
      <button class="button" @click="selectmonth(9)" :class="monthclass(9)">
        <span>Sep</span>
      </button>
      <button class="button" @click="selectmonth(10)" :class="monthclass(10)">
        <span>Oct</span>
      </button>
      <button class="button" @click="selectmonth(11)" :class="monthclass(11)">
        <span>Nov</span>
      </button>
      <button class="button" @click="selectmonth(12)" :class="monthclass(12)">
        <span>Dic</span>
      </button>
      <button
        v-if="iscierre"
        class="button"
        @click="selectmonth(13)"
        :class="monthclass(13)"
      >
        <span>Cie</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    iscierre: Boolean,
    period: Object,
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    monthclass(month) {
      if (this.period.months && this.period.months.indexOf(month) !== -1) {
        return "is-primary";
      } else {
        return "";
      }
    },
    selectyear(sign) {
      const _this = this;
      if (sign === "+") {
        this.$emit("period", {
          year: _this.period.year + 1,
          months: _this.period.months,
        });
      } else {
        this.$emit("period", {
          year: _this.period.year - 1,
          months: _this.period.months,
        });
      }
    },
    selectmonth(selectedmonth) {
      const month = [];
      month.push(selectedmonth);
      this.$emit("period", { year: this.period.year, months: month });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/commons/PeriodselectorV2.vue